import Translate from "src/components/Translate";
import { sCopyright } from "src/styles/sCopyright.module.scss";

function Copyright() {
  return (
    <div className={sCopyright}>
      {`© 2021 `}
      <Translate tKey={`Anandita Yoga`} />
    </div>
  );
}

export default Copyright;
